import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

export enum ChoosePaymentType {
  PAID_IN_CASH = 'PAID_IN_CASH',
  PAYMENT_LINK = 'PAYMENT_LINK',
  PREPAID_CODE = 'PREPAID_CODE',
  FREE_ENTRY = 'FREE_ENTRY',
  CUSTOM = 'CUSTOM',
}

@Component({
  selector: 'app-choose-payment',
  standalone: true,
  imports: [CommonModule, TranslateModule, MatTooltipModule],
  templateUrl: './choose-payment.component.html',
  styleUrl: './choose-payment.component.scss',
})
export class ChoosePaymentComponent {
  @Input() chosenPayment?: ChoosePaymentType;
  @Output() paymentChosen = new EventEmitter<ChoosePaymentType>();

  constructor(private translateService: TranslateService) {}

  choosePayment(payment: ChoosePaymentType) {
    this.chosenPayment = payment;
    this.paymentChosen.emit(payment);
  }

  getPaymentTitle(payment: ChoosePaymentType) {
    const instant =
      'APP.BOOKING_SLOTS.PARTICIPANTS.ADD_PARTICIPANT_PAYMENT_TITLE.' + payment;
    return this.translateService.instant(instant);
  }

  getPaymentDescription(payment: ChoosePaymentType) {
    const instant =
      'APP.BOOKING_SLOTS.PARTICIPANTS.ADD_PARTICIPANT_PAYMENT_DESCRIPTION.' + payment;
    return this.translateService.instant(instant);
  }

  protected readonly AddParticipantPaymentType = ChoosePaymentType;
}
